import React, { useState, useEffect } from 'react';
import { Box, Fab, Zoom, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import InquiryPopup from '../InquiryPopup';

const FloatingActionButtons = () => {
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const phoneNumber = process.env.REACT_APP_PHONE_NUMBER || '+919330415981';
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '+919330415981';

  useEffect(() => {
    const scrollThreshold = isMobile ? 200 : 400;
    const handleScroll = () => {
      setVisible(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Check initial scroll position
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 12, sm: 24 },
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 1, sm: 1.5 },
          zIndex: 1300,
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(20px)',
          pointerEvents: visible ? 'auto' : 'none',
        }}
      >
        {/* Enquiry Button */}
        <Zoom in={visible} style={{ transitionDelay: visible ? '0ms' : '0ms' }}>
          <Tooltip title="Send Enquiry" placement="left">
            <Fab
              onClick={() => setInquiryOpen(true)}
              aria-label="Enquiry"
              sx={{
                bgcolor: '#D4AF37',
                color: 'white',
                width: { xs: 48, sm: 52 },
                height: { xs: 48, sm: 52 },
                '&:hover': {
                  bgcolor: '#B8960E',
                  transform: 'translateY(-3px)',
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(212, 175, 55, 0.4)',
              }}
            >
              <EmailIcon sx={{ fontSize: 28 }} />
            </Fab>
          </Tooltip>
        </Zoom>

        {/* WhatsApp Button */}
        <Zoom in={visible} style={{ transitionDelay: visible ? '200ms' : '0ms' }}>
          <Tooltip title="Chat on WhatsApp" placement="left">
            <Fab
              component="a"
              href={`https://wa.me/${whatsappNumber.replace(/\+/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              sx={{
                bgcolor: '#25D366',
                color: 'white',
                width: { xs: 48, sm: 52 },
                height: { xs: 48, sm: 52 },
                '&:hover': {
                  bgcolor: '#128C7E',
                  transform: 'translateY(-3px)',
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
              }}
            >
              <WhatsAppIcon sx={{ fontSize: 28 }} />
            </Fab>
          </Tooltip>
        </Zoom>

        {/* Call Button */}
        <Zoom in={visible} style={{ transitionDelay: visible ? '400ms' : '0ms' }}>
          <Tooltip title="Call us now" placement="left">
            <Fab
              component="a"
              href={`tel:${phoneNumber}`}
              aria-label="Call"
              sx={{
                background: 'linear-gradient(135deg, #0C2340 0%, #1A3365 100%)',
                color: 'white',
                width: { xs: 48, sm: 52 },
                height: { xs: 48, sm: 52 },
                '&:hover': {
                  background: 'linear-gradient(135deg, #1A3365 0%, #0C2340 100%)',
                  transform: 'translateY(-3px)',
                },
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(12, 35, 64, 0.4)',
              }}
            >
              <CallIcon sx={{ fontSize: 28 }} />
            </Fab>
          </Tooltip>
        </Zoom>
      </Box>

      {/* Inquiry Popup */}
      <InquiryPopup open={inquiryOpen} onClose={() => setInquiryOpen(false)} />
    </>
  );
};

export default FloatingActionButtons;
